import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import withRoot from "../../withRoot";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVert from '@material-ui/icons/MoreVert';

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  menuIconTableCell: {
    width: 100 + "px"
  },
 menuIconContainer: {
    cursor: "pointer",
    padding: 5 + "px"
  },
  detailsTableCell: {
    padding: 0
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.secondary.light,
    },
  },
  searchField: {
    fontSize: '0.9rem',
    fontWeight: 'normal',
  },
  searchIcon: {
    fontSize: '0.9rem',
  },
  searchAdornment: {
    marginRight: '0px',
  }
});

class StationsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRow: -1,
      selectedStation: null,
      searchFieldValues: {
        pumpnumber: '',
        stationCode: '',
        name: '',
        address: '',
        city: ''
      }
    }
  }


  componentDidMount() {
    // Initialize searchfieldvalues from redux state
    this.setState({
      searchFieldValues: {...this.props.searchFieldValues}
    });
  }

  isSelected = (id) => {
    return this.state.selectedRow === id && this.props.useSelectedRow;
  }

  handleClick = (event) => {
   this.handleMenuClose();
   this.setState({ selectedRow: this.state.selectedStation.id });
   this.props.handleEditClick(this.state.selectedStation);
   this.handleMenuClose();
 }

  handleMenuClick = (event, station) => {
    this.setState({ anchorEl: event.currentTarget, selectedStation: station });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null, selectedStation: null });
  };

  handleStationDelete = (event) => {
    event.stopPropagation();
    this.setState({ selectedRow: this.state.selectedStation.id });
    this.props.handleStationDelete(this.state.selectedStation);
    this.handleMenuClose();
  }

  handleSearchFieldChange = (property) => (event) => {
    this.setState({searchFieldValues: {...this.state.searchFieldValues, [property]: event.target.value}})
    this.props.handleSearchFieldChange({[property]: event.target.value});
  }

  filterStationsData = () => {
    let updatedStations = this.props.stations;

    if(this.state.searchFieldValues.pumpnumber !== ''){
      updatedStations = updatedStations.filter( t => {
        const stationPumpNumber = this.state.searchFieldValues.pumpnumber;
        return t.pumpNumber.toString().slice(0, stationPumpNumber.length).includes(stationPumpNumber);
      })
    }
    if(this.state.searchFieldValues.stationCode !== ''){
      updatedStations = updatedStations.filter( t => {
        return t.stationCode.toLowerCase().search(this.state.searchFieldValues.stationCode.toLowerCase()) !== -1;
      })
    }
    if(this.state.searchFieldValues.name !== ''){
      updatedStations = updatedStations.filter( t => {
        return t.name.toLowerCase().search(this.state.searchFieldValues.name.toLowerCase()) !== -1;
      })
    }
    if(this.state.searchFieldValues.address !== ''){
      updatedStations = updatedStations.filter( t => {
        return t.address.toLowerCase().search(this.state.searchFieldValues.address.toLowerCase()) !== -1;
      })
    }
    if(this.state.searchFieldValues.city !== ''){
      updatedStations = updatedStations.filter( t => {
        return t.city.toLowerCase().search(this.state.searchFieldValues.city.toLowerCase()) !== -1;
      })
    }

    return updatedStations;
  }

  render() {
    const { classes, role } = this.props;
    const { anchorEl } = this.state;

    const showStations = this.filterStationsData();
    return (

    <Paper className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>
              <Grid container direction='column'>
                <Grid item>Pump number</Grid>
                <Grid item>
                  <Input
                    id='stationspumpnumber'
                    className={classes.searchField}
                    type='text'
                    value={this.state.searchFieldValues.pumpnumber}
                    onChange={this.handleSearchFieldChange('pumpnumber')}
                    startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                    fullWidth={true}
                    inputProps={{size: 4}}
                  />
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container direction='column'>
                <Grid item>Station code</Grid>
                <Grid item>
                  <Input
                    id='station_id'
                    className={classes.searchField}
                    type='text'
                    value={this.state.searchFieldValues.stationCode}
                    onChange={this.handleSearchFieldChange('stationCode')}
                    startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                    fullWidth={true}
                    inputProps={{size: 4}}
                  />
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container direction='column'>
                <Grid item>Name</Grid>
                <Grid item>
                  <Input
                    id='stationsname'
                    className={classes.searchField}
                    type='text'
                    value={this.state.searchFieldValues.name}
                    onChange={this.handleSearchFieldChange('name')}
                    startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                    fullWidth={true}
                    inputProps={{size: 4}}
                  />
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container direction='column'>
                <Grid item>Address</Grid>
                <Grid item>
                  <Input
                    id='stationsaddress'
                    className={classes.searchField}
                    type='text'
                    value={this.state.searchFieldValues.address}
                    onChange={this.handleSearchFieldChange('address')}
                    startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                    fullWidth={true}
                    inputProps={{size: 4}}
                  />
                </Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container direction='column'>
                <Grid item>City</Grid>
                <Grid item>
                  <Input
                    id='stationsCity'
                    className={classes.searchField}
                    type='text'
                    value={this.state.searchFieldValues.city}
                    onChange={this.handleSearchFieldChange('city')}
                    startAdornment={<InputAdornment position="start" className={classes.searchAdornment}><SearchIcon color='disabled' className={classes.searchIcon}/></InputAdornment>}
                    fullWidth={true}
                    inputProps={{size: 4}}
                  />
                </Grid>
              </Grid>
            </TableCell>
            {role === "admin" && <TableCell className={classes.menuIconTableCell}></TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {showStations.map(t => {
            const isSelected = this.isSelected(t.id);
            return (
              <TableRow className={classes.row} selected={isSelected} key={t.id}>
                <TableCell>{t.pumpNumber}</TableCell>
                <TableCell>{t.stationCode}</TableCell>
                <TableCell>{t.name}</TableCell>
                <TableCell>{t.address}</TableCell>
                <TableCell>{t.city}</TableCell>
                {role === "admin" && <TableCell className={classes.menuIconTableCell}>
                  <span onClick={event => this.handleMenuClick(event, t)} className={classes.menuIconContainer}><MoreVert className={classes.icon} /></span>
                </TableCell>}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={this.handleMenuClose}
      >
        {/* <MenuItem onClick={event => this.handleClick(event)}>Edit</MenuItem> */}
        <MenuItem onClick={event => this.handleStationDelete(event)}>Delete</MenuItem>
      </Menu>
    </Paper>
  );
}

}

StationsTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRoot(withStyles(styles)(StationsTable));



// WEBPACK FOOTER //
// ./src/components/Tables/StationsTable.js